import Vue from 'vue'
// import Vuex from 'vuex'
const App = () => import('./App.vue')
const TeacherProgressReportPage = () => import('./teacher/TeacherProgressReportPage.vue')
const StudentProgressPage = () => import('./student/StudentProgressPage.vue')
const SubscriptionDialog = () => import('./teacher/SubscriptionDialog.vue')
import store from './store'
import VueRouter from 'vue-router'
import {routes} from './vue_routes'
import Utils from 'common/Utils';
import {BASE_PATH, enums} from 'config'
import {isLoggedIn, isTeacher, isAdmin} from '../../common/UserService';
import _ from 'lodash'
import RTGoogleAnalytics from '../../common/RTGoogleAnalytics';
import { RTClarity } from '../../common/clarity';
// import Analytics from './VueAnalytics';
import Story from '../../common/Story';
import log from 'common/Logger';
import VModal from 'vue-js-modal';
import vSelect from 'vue-select';
import NotificationBar from './common/NotificationBar.vue';

import {RTFacebookPixel} from '../../common/fbpixel';
import {trackHubspotPageView} from "../../teachers/hubspot";

export function loadVue(selector = '#vapp', childComponent = null) {

  log.info('loading Vue.js')
  Vue.config.errorHandler = function (err, vm, info) {
    // handle error
    // `info` is a Vue-specific error info, e.g. which lifecycle hook
    // the error was found in. Only available in 2.2.0+
    const msg = `Uncaught runtime error: ${JSON.stringify(err)}` + info ? 'info: '+JSON.stringify(info) : '';
    log.error(msg, err)
  };

  //global libs and plugins
  Vue.use(VModal, { dialog: true })
  Vue.use(VueRouter);
  Vue.component('v-select', vSelect);
  Vue.component('notification-bar', NotificationBar);

  const caretTemplate = `
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6">
      <path fill="#3882FD" fill-rule="evenodd" d="M4.964 5.779a.597.597 0 0 1-.928 0L1.767 3.176.191 1.32C-.219.836.074.017.66.015L4.5 0l3.84.015c.586.002.88.82.469 1.304L7.233 3.176 4.963 5.78z"/>
    </svg>`;

  vSelect.props.components.default = () => ({
    OpenIndicator: {
      render: function(createElement) {
        return Vue.compile(caretTemplate).render.call(this, createElement);
      },
    },
  });
  // Vue.config.productionTip = false;
  // Vue.use(Vuex)
  const router = new VueRouter({
    routes,
    mode: 'history',
    base: `${BASE_PATH}/`,
  });
  router.beforeEach((to, from, next) => {
    let isNotLoginedRoute = _.includes(['role-select', 'create-account'], to.name)
    if (isNotLoginedRoute && isLoggedIn()) {
      next({ path: '/welcome/userHome' })
      window.location.reload();
    }
    let isTeacherOnlyRoute = _.includes(['add-student','create-class'], to.name);
    if (isTeacherOnlyRoute && !isTeacher()) {
      log.warn(`Non teacher user in teacher path`)
      next(false)
      return;
    }
    const isAdminOnlyRoute = _.includes(['coppa-contracts'], to.name);
    if (isAdminOnlyRoute && !isAdmin()) {
      log.warn(`Non admin user in admin path`)
      next(false)
      return;
    }
    const isSignupMoreInfoRoute = (to.name === 'update-info' && from.name === 'signup-pricing')
    if (isSignupMoreInfoRoute) {
      store.commit('teacher/updateSignupStatus', enums.signUpStatus.UPDATE_INFO);
    }
    next();
  });
  router.afterEach(( to, from ) => {
    // Analytics.trackPageView(to.path);
    if (to.name === 'signup-pricing' && isLoggedIn()) {
	  RTClarity.load();
    }
    if (to.name === from.name) return;
    if (!_.isEmpty(to.name)) {
      const extraFields = {param1: to.name}
      const ref = from.query.ref
      if (ref) {
        extraFields['param2'] = ref
      }
      let counter = 3;
      _.forEach(to.params, (val, key) => extraFields['param'+counter++] = val)
      Story.addStep('pv', extraFields)
      if (window.customerly) {
        log.info('Customery update called')
        window.customerly.update()
      }
      RTFacebookPixel.trackPageView(to.path)
      trackHubspotPageView(to.path)
    }

  });

  if (!_.isEmpty(Utils.getUrlParams()['ref'])) {
    localStorage.setItem('ref',Utils.getUrlParams()['ref'])
  }

  let template = '<App/>';
  const components = { App }
  if (childComponent === 'class-progress') {
    template = '<App><TeacherProgressReportPage :customReport="false"/></App>';
    components.TeacherProgressReportPage = TeacherProgressReportPage
  } else if (childComponent === 'student-progress') {
	template = '<App><StudentProgressPage /></App>';
    components.StudentProgressPage = StudentProgressPage
  } else if (childComponent === 'subscription-dialog') {
    template = '<App><SubscriptionDialog type="support"/></App>';
    components.SubscriptionDialog = SubscriptionDialog
  }
  /* eslint-disable no-new */
  new Vue({
    el: selector,
    template,
    components,
    router,
    methods: {
      goBack () {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/')
      }
    },
    store
  });

  Utils.loadStyle("https://fonts.googleapis.com/css2?family=IBM+Plex+Serif:wght@700&display=swap");
  Utils.loadStyle("https://fonts.googleapis.com/css?family=Open+Sans:300,400,600&display=swap");
  Utils.loadStyle("https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap");
  Utils.loadStyle("https://fonts.googleapis.com/css?family=IBM+Plex+Serif&display=swap");
  Utils.loadStyle("https://cdn.jsdelivr.net/npm/vue-toast-notification/dist/theme-sugar.css");
  Utils.loadStyle("https://unpkg.com/vue-select@latest/dist/vue-select.css");
}
